import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { cleanEmpty } from 'utils/genericFunctions';
import { ReducerActionRotaSP } from 'store/modules/types';
import { RequestConsultarMenus, Types } from './types';

// ACTIONS
import { consultarMenusSuccess, consultarMenusFailure } from './action';

function* consultarMenus(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: RequestConsultarMenus } =
		request;

	let body = { ...payload };

	body = cleanEmpty(body) as RequestConsultarMenus;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`menu`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarMenusSuccess(response));
	} else if (response.error) {
		yield put(consultarMenusFailure());
	}
}

export default all([takeLatest(Types.CONSULTAR_MENUS, consultarMenus)]);
